import axios from "@/common/http";

export default {
  state: () => ({}),
  mutations: {},
  actions: {
    // 工作台列表
    async copytasklist({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytasklist", data);
      return res;
    },
    // 工作台列表任务更新
    async copytaskupdate({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskupdate", data);
      return res;
    },
    // 背景图列表
    async backgroundlist({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/backgroundlist", data);
      return res;
    },
    // 人脸图列表
    async facelist({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/facelist", data);
      return res;
    },
    // 模型列表
    async modellist({ commit }, data) {
      const res = await axios.post("/v1/stablediffusion/getmodellist", data);
      return res;
    },
    // 提示词列表
    async promptextlist({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/promptext/list", data);
      return res;
    },

    // 发起SD制作
    async copytaskcreate({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskcreate", data);
      return res;
    },
    // 重新制作
    async copytaskremake({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskremake", data);
      return res;
    },

    // SD结果图确认
    async copytaskselectimage({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskselectimage", data);
      return res;
    },
    // 完成制作提交给用户
    async copytaskcompleted({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskcompleted", data);
      return res;
    },
    // 遮罩细化接口
    async copytaskmaskfix({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskmaskfix", data);
      return res;
    },
    // SD结果图片重传
    async copytaskupdatesdimage({ commit }, data) {
      const res = await axios.post(
        "/v1/fashionlabs/copytaskupdatesdimage",
        data
      );
      return res;
    },
    // 图片反推Prompt接口（工作台)
    async imagetoprompt({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/imagetoprompt", data);
      return res;
    },
    // 获取Prompt接口（工作台）
    async getprompt({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/getprompt", data);
      return res;
    },
    // 删除复制的任务
    async copytaskdelete({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskdelete", data);
      return res;
    },
    // 重新编辑任务
    async copytaskreedit({ commit }, data) {
      const res = await axios.post("/v1/fashionlabs/copytaskreedit", data);
      return res;
    },
  },
  getters: {},
};
